import { submitDtfArtworkProcolorRoutableTagged } from "./submit-dtf-events";

// PIP-3054: shared dispatcher for the dtf_artwork_procolor_routable_tagged event.
// Accepts either a snake_case WebSocket payload or a camelCased ArtworkItem from
// the store. delta_e/threshold/profile/percentile fields are null when the source
// is the list endpoint (DtfArtworkListSerializer) — it omits routing details.
/* eslint-disable camelcase, max-lines-per-function */
// eslint-disable-next-line import/prefer-default-export
export const submitProcolorRoutableTaggedForArtwork = (artwork, { multiArtwork }) => {
  if (!artwork) return;
  const routable = artwork.procolor_routable ?? artwork.procolorRoutable;

  // Distinguish false (backend evaluated, not routable — expected skip) from
  // undefined/null (field entirely absent — likely a serializer regression).
  if (routable === false) return;
  if (routable === undefined || routable === null) {
    // Both snake_case and camelCase forms are absent. This is unexpected when
    // the artwork has an id and is past the analysis stage — log at info level
    // so it is observable in production without being noisy.
    const artworkId = artwork.id ?? artwork.artwork_id ?? artwork.artworkId;
    if (artworkId) {
      // eslint-disable-next-line no-console
      console.warn("[PIP-3054] procolor_routable field missing on artwork", { artworkId });
    }
    return;
  }

  const details = artwork.procolor_routing_details ?? artwork.procolorRoutingDetails ?? null;
  const artworkId = artwork.id ?? artwork.artwork_id ?? artwork.artworkId;
  const routingMode = artwork.procolor_routing_mode ?? artwork.procolorRoutingMode ?? null;

  // The server nests the procolor-specific delta_e and profile_sha256 under
  // `procolor.*`, parallel to a `cmyk.*` block. Older code paths (and the
  // synthetic test fixtures) used a flat shape — fall back to it for safety.
  const procolor = details?.procolor ?? details?.procolor_block ?? null;
  const deltaE =
    procolor?.delta_e_value ??
    procolor?.deltaEValue ??
    details?.delta_e_value ??
    details?.deltaEValue ??
    null;
  const profileSha =
    procolor?.profile_sha256 ??
    procolor?.profileSha256 ??
    details?.profile_sha256 ??
    details?.profileSha256 ??
    null;

  submitDtfArtworkProcolorRoutableTagged({
    artwork_id: artworkId,
    procolor_routing_mode: routingMode,
    procolor_delta_e: deltaE,
    procolor_threshold: details?.threshold ?? null,
    procolor_profile_sha256: profileSha,
    procolor_percentile_label: details?.percentile_label ?? details?.percentileLabel ?? null,
    multi_artwork: multiArtwork
  });
};
/* eslint-enable camelcase, max-lines-per-function */
